<a
  *ngFor="let item of items"
  (click)="selectItem(item)"
  class="anchor"
  [ngClass]="{ 'highlight-red': item.critical, 'disabled': item.disabled }"
  [class.disabled]="item.disabled"
  [attr.aria-disabled]="item.disabled"
  >{{ item[visibleField] }}</a
>
